/**
 * @ts-check
 * @prettier
 * @author Alexander Nagelberg
 * @author Victoria Saleem
 **/
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'

import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'
import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'
import LgyLink from 'app/components/util/lgy-link/LgyLink'
import RefundRecordForm from '../components/RefundRecordForm'
import RefundHistory from '../components/RefundHistory'
import RefundNavigationBar from '../components/RefundNavigationBar'
import RefundNotesTable from '../components/RefundNotesTable'
import { loadRefund, updateRefundRecord, validateRefund } from '../actions/fundingfeeActions'
import { URLs } from '../utils/refundUtils'

import '../style/fundingfee.scss'

// Stateless props are defined here
const RefundRecordContainer = props => {
  const { id: refundId } = useParams()
  const { loadRefund, updateRefundRecord, validateRefund, fundingFee, isAffiliate, authorizations } = props
  const { validationSucceeded } = fundingFee
  const refundStatus = fundingFee[refundId]?.status
  const validation = refundStatus !== 'PAID' && refundStatus !== 'PAID_BY_VOUCHER'
  const readOnly = !authorizations?.some(authorizations => authorizations === 'Edit Funding Fee Refund Record')

  // Load initial values in
  useEffect(() => {
    loadRefund(refundId)
    //clear validation flag
    return () => {
      /* clear validation flag */
    }
  }, [loadRefund, refundId])

  return (
    <div className='lgy-funding-fee-refund'>
      <RefundNavigationBar />

      {fundingFee.error && (
        <LgyAlertDialog type='error' heading='Error' paragraph>
          Error loading refund
        </LgyAlertDialog>
      )}

      {validationSucceeded != null && (
        <LgyAlertDialog type='info' heading='Refund Validated'>
          Refund {validationSucceeded ? 'passed' : 'failed'} validation.
        </LgyAlertDialog>
      )}

      {!fundingFee[refundId] && <LgyLoadingIcon />}
      {fundingFee[refundId] && (
        <div>
          {fundingFee.fetching && <LgyLoadingIcon />}
          {validation && !readOnly && (
            <button type='button' onClick={() => validateRefund(refundId)}>
              Validate Refund
            </button>
          )}

          <RefundRecordForm
            form={`refundRecordForm${refundId}`}
            onSubmit={updateRefundRecord}
            fundingFee={fundingFee}
            initialValues={fundingFee[refundId]}
            enableReinitialize
            authorizations={authorizations}
            readOnlyUser={readOnly}
          />
          <p>Notes:</p>
          <LgyLink to={`${URLs.FUNDING_FEE_REFUND_APP_PATH}/${refundId}/note`}>
            <button>Add New Note</button>
          </LgyLink>
          <RefundNotesTable notes={fundingFee[refundId]?.notes} isAffiliate={isAffiliate ?? true} />
          <p>History:</p>
          <RefundHistory events={fundingFee[refundId]?.events} />
        </div>
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  fundingFee: state.fundingFee,
  isAffiliate: state.currentUser?.isAffiliate,
  authorizations: state.currentUser?.authorizations
})

const mapDispatchToProps = {
  loadRefund,
  updateRefundRecord,
  validateRefund
}

export default connect(mapStateToProps, mapDispatchToProps)(RefundRecordContainer)
